var map = {
	"./_cod.svg": "d43f",
	"./bay.svg": "230a",
	"./bbl.svg": "dcd6",
	"./cod.svg": "b041f",
	"./ghb.svg": "3fd3",
	"./gsb.svg": "6996",
	"./ibank.svg": "5278",
	"./kbank.svg": "296a",
	"./kk.svg": "3ab8",
	"./ktb.svg": "daaa",
	"./lhb.svg": "4b5f",
	"./scb.svg": "87db",
	"./tbank.svg": "1b62",
	"./tmb.svg": "f9fe",
	"./uob.svg": "68ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0aa3";